module.exports = __webpack_public_path__ + "img/care-charity-community-service-1559106.15ecae10.jpg";